import { render, staticRenderFns } from "./PackageTabFields.vue?vue&type=template&id=4d9d0cd7&scoped=true&"
import script from "./PackageTabFields.vue?vue&type=script&lang=js&"
export * from "./PackageTabFields.vue?vue&type=script&lang=js&"
import style0 from "./PackageTabFields.vue?vue&type=style&index=0&id=4d9d0cd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9d0cd7",
  null
  
)

export default component.exports